<template>
  <div class="bg-white is-rounded">
    <div class="modal-body text-center p-2 is-flex">
      <div class="flex-no-shrink">
        <div
          class="info-icon is-flex align-items-center justify-content-center"
          :class="iconClass || 'is-danger'"
        >
          <div class="icon">
            <ion-icon :name="icon || 'warning-outline'" />
          </div>
        </div>
      </div>
      <div class="flex-grow pl-5">
        <div
          v-if="title"
          class="mb"
        >
          <h5 class="title is-5">{{ title }}</h5>
        </div>
        <div
          class="text-muted"
          v-if="text && useHtml"
          v-html="text"
        />
        <div
          class="text-muted"
          v-else-if="text"
        >
          {{ text }}
        </div>
        <slot />
      </div>
    </div>
    <div
      v-if="$slots.actions"
      class="is-flex w-100 justify-content-end pl-3 pr-3 pt-1 pb-1 bg-gray-100 is-rounded-bottom"
    >
      <slot name="actions" />
    </div>
    <div
      class="is-flex w-100 justify-content-end pl-3 pr-3 pt-1 pb-1 bg-gray-100 is-rounded-bottom"
      v-else-if="actions === null"
    >
      <a
        href="#"
        class="button mr"
        @click.prevent.stop="resetAndDismiss"
      >
        {{ cancel }}
      </a>
      <button
        type="button"
        class="button"
        :class="[iconClass || 'is-danger', { 'is-loading': showLoader }]"
        @click.prevent.stop="onConfirmClick"
        :disabled="showLoader"
      >
        {{ ok }}
      </button>
    </div>
    <div
      class="is-flex w-100 justify-content-end pl-3 pr-3 pt-1 pb-1 bg-gray-100 is-rounded-bottom"
      v-else
    >
      <a
        href="#"
        class="button mr"
        :class="action.class"
        v-for="action in actions"
        @click.prevent.stop="callAction(action.onPress)"
      >
        {{ action.label }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationAlert",
  props: {
    ok: { required: false, type: String, default: "Confirm" },
    cancel: { required: false, type: String, default: "Cancel" },
    text: { required: false, type: String, default: "" },
    title: { required: false, type: String, default: "" },
    actions: { required: false, type: [Array, Object], default: null },
    icon: { required: false, type: String, default: "warning-outline" },
    iconClass: { required: false, type: String, default: "is-danger" },
    showLoader: { type: Boolean, default: false },
    useHtml: { type: Boolean, default: false },
  },
  emits: ["dismiss", "confirm"],

  methods: {
    callAction(callback) {
      callback()
      this.$emit("dismiss")
    },

    onConfirmClick() {
      this.$emit("confirm", this.onResponse)
    },

    onResponse() {
      this.$emit("dismiss")
    },

    resetAndDismiss() {
      this.onResponse()
    },
  },
}
</script>

<style scoped>
.info-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.info-icon > .icon > ion-icon {
  width: 24px;
  height: 24px;
  position: relative;
  top: -1px;
}

.info-icon.is-danger {
  background-color: #feebeb;
  color: #d54041;
}

.info-icon.is-success {
  background-color: #effaf1;
  color: #319853;
}
</style>
